import OrganizationIndexPage from "./OrganizationIndexPage";
export default OrganizationIndexPage;
